module.exports = __webpack_public_path__ + "static/media/basic programming.68e3f935.png";